/**
 * Make one's answer, kept across the trip to /join or /signin.
 *
 * A stranger pastes a model's answer into Make one and presses Add; adding takes an account, and
 * creating one is a page of its own (src/lib/join.ts), so the feed is left. The answer — and the
 * maker's Made with word — waits in this tab's sessionStorage and is put back when Make one opens
 * again: from /join's "Add what you made" (/feed?link=1, which opens on Make one while a draft
 * waits) or from /feed?make=1. It is taken once, and never leaves the tab.
 */
const KEY = 'blitz:make-draft';

export interface MakeDraft {
  made: string;
  madeWith: string;
}

function storage(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null; // blocked storage throws on access
  }
}

export function saveMakeDraft(d: MakeDraft): void {
  try {
    if (d.made.trim()) storage()?.setItem(KEY, JSON.stringify(d));
  } catch {
    /* full or blocked: the answer is lost, as it was before this existed */
  }
}

export function hasMakeDraft(): boolean {
  try {
    return storage()?.getItem(KEY) != null;
  } catch {
    return false;
  }
}

/** The waiting draft, removed as it is read; null when there is none or it does not parse. */
export function takeMakeDraft(): MakeDraft | null {
  const s = storage();
  try {
    const raw = s?.getItem(KEY);
    if (!raw) return null;
    s?.removeItem(KEY);
    const d = JSON.parse(raw) as Partial<MakeDraft>;
    return typeof d.made === 'string' && d.made.trim() ? { made: d.made, madeWith: typeof d.madeWith === 'string' ? d.madeWith : '' } : null;
  } catch {
    return null;
  }
}
